export const DEFAULT_PROCESS_CONDITIONS_PCF_ATTRIBUTE_NAMES: Record<string, string> = {
  processConditions: 'PROCESS-CONDITIONS',
  pipingSpecPc: 'PIPING-SPEC-PC',
  tracingSpecPc: 'TRACING-SPEC-PC',
  attribute12: 'ATTRIBUTE-12',
  attribute13: 'ATTRIBUTE-13',
  attribute14: 'ATTRIBUTE-14',
  attribute15: 'ATTRIBUTE-15',
  attribute16: 'ATTRIBUTE-16',
  attribute17: 'ATTRIBUTE-17',
  attribute18: 'ATTRIBUTE-18',
  attribute19: 'ATTRIBUTE-19',
  attribute20: 'ATTRIBUTE-20',
  attribute21: 'ATTRIBUTE-21',
  attribute22: 'ATTRIBUTE-22',
  attribute23: 'ATTRIBUTE-23',
};

export const PROCESS_CONDITIONS_EDITOR_ROW_ORDER = [
  'processConditions',
  'pipingSpecPc',
  'tracingSpecPc',
  'attribute12',
  'attribute13',
  'attribute14',
  'attribute15',
  'attribute16',
  'attribute17',
  'attribute18',
  'attribute19',
  'attribute20',
  'attribute21',
  'attribute22',
  'attribute23',
] as const;

export const PROJECT_PROPERTIES_EDITOR_ROW_ORDER = [
  'projectProperties',
  'projectIdentifier',
  'projectName',
  'area',
  'attribute1',
  'attribute2',
  'attribute3',
  'attribute4',
  'attribute5',
  'attribute6',
  'attribute7',
  'attribute8',
  'attribute9',
  'attribute10',
] as const;

export const DEFAULT_PROJECT_PROPERTIES_PCF_ATTRIBUTE_NAMES: Record<string, string> = {
  projectProperties: 'PROJECT-PROPERTIES',
  projectIdentifier: 'PROJECT-IDENTIFIER',
  projectName: 'PROJECT-NAME',
  area: 'AREA',
  attribute1: 'ATTRIBUTE-1',
  attribute2: 'ATTRIBUTE-2',
  attribute3: 'ATTRIBUTE-3',
  attribute4: 'ATTRIBUTE-4',
  attribute5: 'ATTRIBUTE-5',
  attribute6: 'ATTRIBUTE-6',
  attribute7: 'ATTRIBUTE-7',
  attribute8: 'ATTRIBUTE-8',
  attribute9: 'ATTRIBUTE-9',
  attribute10: 'ATTRIBUTE-10',
};

export const PROCESS_CONDITIONS_FIELD_BY_EDITOR_ROW_ID = {
  processConditions: 'processConditionsValue',
  pipingSpecPc: 'pipingSpecValuePC',
  tracingSpecPc: 'tracingSpecValuePC',
  attribute12: 'attribute12Value',
  attribute13: 'attribute13Value',
  attribute14: 'attribute14Value',
  attribute15: 'attribute15Value',
  attribute16: 'attribute16Value',
  attribute17: 'attribute17Value',
  attribute18: 'attribute18Value',
  attribute19: 'attribute19Value',
  attribute20: 'attribute20Value',
  attribute21: 'attribute21Value',
  attribute22: 'attribute22Value',
  attribute23: 'attribute23Value',
} as const;

export const PROCESS_CONDITIONS_PROFILE_PARAMETER_BY_EDITOR_ROW_ID = {
  processConditions: 'PROCESS-CONDITIONS',
  pipingSpecPc: 'PIPING-SPEC',
  tracingSpecPc: 'TRACING-SPEC',
  attribute12: 'ATTRIBUTE12',
  attribute13: 'ATTRIBUTE13',
  attribute14: 'ATTRIBUTE14',
  attribute15: 'ATTRIBUTE15',
  attribute16: 'ATTRIBUTE16',
  attribute17: 'ATTRIBUTE17',
  attribute18: 'ATTRIBUTE18',
  attribute19: 'ATTRIBUTE19',
  attribute20: 'ATTRIBUTE20',
  attribute21: 'ATTRIBUTE21',
  attribute22: 'ATTRIBUTE22',
  attribute23: 'ATTRIBUTE23',
} as const;

export const PROCESS_CONDITIONS_EDITOR_ROW_ID_BY_FIELD = Object.fromEntries(
  Object.entries(PROCESS_CONDITIONS_FIELD_BY_EDITOR_ROW_ID).map(([rowId, fieldName]) => [
    fieldName,
    rowId,
  ])
) as Record<
  (typeof PROCESS_CONDITIONS_FIELD_BY_EDITOR_ROW_ID)[keyof typeof PROCESS_CONDITIONS_FIELD_BY_EDITOR_ROW_ID],
  keyof typeof PROCESS_CONDITIONS_FIELD_BY_EDITOR_ROW_ID
>;

export const PROJECT_PROPERTIES_FIELD_BY_EDITOR_ROW_ID = {
  projectProperties: 'projectPropertiesValue',
  projectIdentifier: 'projectIdentifierValue',
  projectName: 'projectNameValue',
  area: 'areaValue',
  attribute1: 'attribute1ClientName',
  attribute2: 'attribute2ProjectAddress',
  attribute3: 'attribute3ClientDepartment',
  attribute4: 'attribute4ClientProjectNumber',
  attribute5: 'attribute5ClientDocumentNumber',
  attribute6: 'attribute6ClientCode',
  attribute7: 'attribute7EngPartyOffice',
  attribute8: 'attribute8EngPartyOfficeLocation',
  attribute9: 'attribute9EngPartyProjectNumber',
  attribute10: 'attribute10EngPartyAreaCode',
} as const;

export const PROJECT_PROPERTIES_PROFILE_PARAMETER_BY_EDITOR_ROW_ID = {
  projectProperties: 'PROJECT-PROPERTIES',
  projectIdentifier: 'PROJECT-IDENTIFIER',
  projectName: 'PROJECT-NAME',
  area: 'AREA',
  attribute1: 'ATTRIBUTE1',
  attribute2: 'ATTRIBUTE2',
  attribute3: 'ATTRIBUTE3',
  attribute4: 'ATTRIBUTE4',
  attribute5: 'ATTRIBUTE5',
  attribute6: 'ATTRIBUTE6',
  attribute7: 'ATTRIBUTE7',
  attribute8: 'ATTRIBUTE8',
  attribute9: 'ATTRIBUTE9',
  attribute10: 'ATTRIBUTE10',
} as const;

export const PROJECT_PROPERTIES_EDITOR_ROW_ID_BY_FIELD = Object.fromEntries(
  Object.entries(PROJECT_PROPERTIES_FIELD_BY_EDITOR_ROW_ID).map(([rowId, fieldName]) => [
    fieldName,
    rowId,
  ])
) as Record<
  (typeof PROJECT_PROPERTIES_FIELD_BY_EDITOR_ROW_ID)[keyof typeof PROJECT_PROPERTIES_FIELD_BY_EDITOR_ROW_ID],
  keyof typeof PROJECT_PROPERTIES_FIELD_BY_EDITOR_ROW_ID
>;
